// dashboard-state.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { MenuData, MenuType, MenuItem } from '../interfaces/menu.interface';


@Injectable({
  providedIn: 'root'
})
export class DashboardStateService {
  private menuDataSubject = new BehaviorSubject<MenuData>({
    title: 'Dashboard',
    typeMenu: MenuType.HOME,
    showBackButton: false,
    showCreateButton: false,
    additionalButtons: [],
    currentData: null,
    menuItems: this.getDefaultMenuItems()
  });

  menuData$ = this.menuDataSubject.asObservable();

  updateMenu(data: Partial<MenuData>) {
    const currentData = this.menuDataSubject.value;
    this.menuDataSubject.next({ ...currentData, ...data });
  }

  setMenuData(data: Partial<MenuData>) {
    const currentData = this.menuDataSubject.value;
    this.menuDataSubject.next({ ...currentData, ...data });
  }

  resetMenu() {
    this.menuDataSubject.next({
      title: 'Dashboard',
      typeMenu: MenuType.HOME,
      showBackButton: false,
      showCreateButton: false,
      additionalButtons: [],
      currentData: null,
      menuItems: this.getDefaultMenuItems()
    });
  }

  private getDefaultMenuItems(): MenuItem[] {
    return [
      {
        label: 'Organizadores',
        icon: '📁',
        route: '/organizadores'
      },
      {
        label: 'Eventos',
        icon: '📅',
        route: '/eventos'
      },
      {
        label: 'Configuraciones',
        icon: '',
        isSectionTitle: true
      },
      {
        label: 'Ajustes Generales',
        icon: '⚙️',
        route: '#'
      },
      {
        label: 'Seguridad',
        icon: '🔒',
        route: '#'
      }
    ];
  }

  setMenuType(typeMenu: MenuType) {
    const currentData = this.menuDataSubject.value;
    this.menuDataSubject.next({ ...currentData, typeMenu });
  }

  getMenuType(): MenuType {
    return this.menuDataSubject.value.typeMenu;
  }
}